<template>
  <div :class="$style.sectionSocialMedia">
    <div class="section">
      <div class="grid--1x3">
        <div class="social-media-item">
          <img src="@assets/dingbeauty-images/contact/icon_mail.svg" alt="" />
          <p>service@ipet-booking.com</p>
        </div>
        <div class="social-media-item middle-icon">
          <img src="@assets/dingbeauty-images/contact/icon_phone.svg" alt="" />
          <p>02-1234-5678</p>
        </div>
        <div class="social-media-item">
          <img src="@assets/dingbeauty-images/contact/icon_FB.svg" alt="" />
          <p>Ding Beauty</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" module>
.sectionSocialMedia {
  background: #fefdfb;

  :global {
    .grid--1x3 {
      display: grid;
      gap: 1rem;
      padding: 0 20px;

      .social-media-item {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          margin-right: 8px;
        }

        p {
          font-size: 16px;
          color: #121931;
          margin: 0;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .sectionSocialMedia {
    :global {
      .section {
        padding: 100px 0;
      }
      .grid--1x3 {
        padding: 0;
        grid-template-columns: repeat(3, 1fr);

        .social-media-item {
          display: block;
          text-align: center;
          padding: 40px 0;

          img {
            width: auto;
            height: 36px;
            margin-bottom: 1rem;
          }
        }

        .middle-icon {
          border-left: 1px solid rgb(84, 86, 98, 0.5);
          border-right: 1px solid rgb(84, 86, 98, 0.5);
        }
      }
    }
  }
}
</style>
